export default __webpack_public_path__ + "static/media/background.cb261475.jpg";